import type { ClipboardPreview } from "@/types";

// Use a DOM CustomEvent instead of a module-local Set so the preview sync
// keeps working reliably across HMR/module duplication scenarios.
const PREVIEW_EVENT = "mfc:preview-request";

// Also keep the last payload so late subscribers still receive the most recent preview
// (prevents a race on initial mount).
let lastPreview: ClipboardPreview | null = null;

type Listener = (preview: ClipboardPreview) => void;

export function onPreviewRequest(fn: Listener) {
  if (lastPreview) fn(lastPreview);

  const handler = ((e: Event) => {
    const ce = e as CustomEvent<ClipboardPreview>;
    lastPreview = ce.detail;
    fn(ce.detail);
  }) as EventListener;

  window.addEventListener(PREVIEW_EVENT, handler);
  return () => window.removeEventListener(PREVIEW_EVENT, handler);
}

export function getLastPreview(): ClipboardPreview | null {
  return lastPreview;
}

export function emitPreviewRequest(preview: ClipboardPreview) {
  lastPreview = preview;
  window.dispatchEvent(new CustomEvent<ClipboardPreview>(PREVIEW_EVENT, { detail: preview }));
}
